import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Label } from "../ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";

export const UnitPicker = ({ operationId, unitId, onChange, compact = false }) => {
  const [ops, setOps] = useState([]);
  const [units, setUnits] = useState([]);
  useEffect(() => { api.get("/operations").then((r) => setOps(r.data)).catch(() => setOps([])); }, []);
  useEffect(() => {
    if (!operationId) return setUnits([]);
    api.get("/units", { params: { operation_id: operationId } }).then((r) => setUnits(r.data)).catch(() => setUnits([]));
  }, [operationId]);
  return (
    <div className={`grid gap-3 ${compact ? "" : "sm:grid-cols-2"}`} data-testid="unit-picker">
      <div className="space-y-1">
        <Label className="text-xs">Operazione</Label>
        <Select value={operationId || ""} onValueChange={(v) => onChange({ operation_id: v, unit_id: "" })}>
          <SelectTrigger data-testid="picker-operazione"><SelectValue placeholder="scegli l'operazione…" /></SelectTrigger>
          <SelectContent>{ops.map((o) => <SelectItem key={o.id} value={o.id}>{o.nome_operazione}{o.comune ? ` · ${o.comune}` : ""}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <div className="space-y-1">
        <Label className="text-xs">Appartamento</Label>
        <Select value={unitId || ""} onValueChange={(v) => onChange({ operation_id: operationId, unit_id: v })} disabled={!operationId}>
          <SelectTrigger data-testid="picker-unita"><SelectValue placeholder={operationId ? "scegli l'appartamento…" : "prima l'operazione"} /></SelectTrigger>
          <SelectContent>{units.map((u) => <SelectItem key={u.id} value={u.id}>{u.denominazione_commerciale}{u.piano ? ` · piano ${u.piano}` : ""}{u.cliente ? ` · ${u.cliente}` : ""} ({u.stato})</SelectItem>)}</SelectContent>
        </Select>
      </div>
    </div>
  );
};
